export const itLottomaticaservizi = {
  modal: {
    geolocation: {
      content:
        'Lottomatica Servizi sta per chiederti di accedere alla tua posizione per una migliore fruizione del servizio.',
      title: 'Geolocalizzazione Lottomatica Servizi',
    },
  },
  namespaceTest: 'Ciao Lottomatica Servizi',
};
